
import React from 'react';
import CartModal from './CartModal';

interface CartProviderProps {
  children: React.ReactNode;
}

export const CartProvider: React.FC<CartProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <CartModal />
    </>
  );
};

export default CartProvider;
